/**
 * Mid-depth civilization state machine.
 * stable → chaos: destroy (cycle++); chaos → stable: rebirth (civId++).
 */

export function createCivilizationState() {
  return {
    civId: 1,
    cycleCount: 0,
    lastKey: 'stable',
  };
}

/**
 * @param {{ civId: number, cycleCount: number, lastKey: string }} state
 * @param {'stable'|'scorching'|'freezing'} key
 * @returns {{ type: 'destroy'|'rebirth', civId: number, cause?: string, year?: number } | null}
 */
export function noteTemperature(state, key, meta = {}) {
  const prev = state.lastKey;
  if (key === prev) return null;

  let event = null;
  const chaos = key === 'scorching' || key === 'freezing';
  const wasChaos = prev === 'scorching' || prev === 'freezing';

  if (prev === 'stable' && chaos) {
    state.cycleCount += 1;
    event = {
      type: 'destroy',
      civId: state.civId,
      cause: key,
      year: meta.year,
    };
  } else if (wasChaos && key === 'stable') {
    state.civId += 1;
    event = {
      type: 'rebirth',
      civId: state.civId,
      year: meta.year,
    };
  } else if (wasChaos && chaos && key !== prev) {
    // scorching ↔ freezing still chaos — no new destroy/rebirth
    event = null;
  }

  state.lastKey = key;
  return event;
}

export function resetCivilizationState(state) {
  state.civId = 1;
  state.cycleCount = 0;
  state.lastKey = 'stable';
}
